import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CheckboxComp from "themes/elements/Checkbox";
import DatePickerComp from "themes/elements/DatePicker";
import ModalComp from "themes/elements/Modal";
import TimePickerComp from "themes/elements/TimePicker";
import ModalFooter from "../modalFooter";

function DateTime({
  formData,
  Approval,
  tabActive,
  setFormData,
  isLoading,
  open,
  setOpen,
  change,
  onSubmit,
  expiryDate,
  onCancel,
}) {
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);

  useEffect(() => {
    setDate(null);
    setTime(null);
  }, [open]);

  const validation = () => {
    const errors = [];
    const today = dayjs().startOf("day");
    const currentTime = dayjs().startOf("minute");

    if (formData.schedule_publish) {
      if (!date) {
        errors.scheduleDate = "Schedule date is required";
      } else {
        const scheduleDate = dayjs(date, "DD-MM-YYYY");
        if (scheduleDate.isBefore(today)) {
          errors.scheduleDate = "Schedule date must be in the future";
        } else if (scheduleDate.isSame(today, "day") && time) {
          const scheduleTime = dayjs(time, "HH:mm");
          if (scheduleTime.isBefore(currentTime)) {
            errors.schedule_time = "Schedule time must be in the future";
          }
        }
      }
      if (!time) {
        errors.scheduleTime = "Schedule time is required";
      }
    }

    return errors;
  };

  const checkValidation = () => {
    const errors = validation();
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((errorMessage) => {
        toast.warning(errorMessage);
      });
    } else {
      onSubmit();
    }
  };

  const disableStartDate = (current) => {
    const today = dayjs().startOf("day");
    const expiryDate2 = expiryDate
      ? dayjs(expiryDate, "DD-MM-YYYY").endOf("day")
      : null;

    return (
      current && (current < today || (expiryDate2 && current > expiryDate2))
    );
  };

  const handleCancel = () => {
    setOpen(false);
    onCancel();
  };

  const handleCheckBox = (value) => {
    if (!value) {
      setFormData((prev) => ({
        ...prev,
        schedule_date: null,
        schedule_time: null,
      }));
      setDate(null);
      setTime(null);
    }
    setFormData((prev) => ({
      ...prev,
      schedule_publish: value,
    }));
  };

  const handleDatePicker = (dateString) => {
    setFormData((prevData) => ({
      ...prevData,
      schedule_date: dateString,
      schedule_time: null,
    }));
    setDate(dateString);
    setTime(null);
  };

  const handleTimePicker = (time, time12HourFormat, time24HourFormat) => {
    setFormData((prevData) => ({
      ...prevData,
      schedule_time: time24HourFormat,
    }));
    setTime(time24HourFormat);
  };

  return (
    <ModalComp
      title={change ? "Change Schedule date" : "Approve this news article?"}
      footer={
        <ModalFooter
          handlePrimaryBtn={handleCancel}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isLoading}
          handleSecondaryBtn={checkValidation}
          secondaryBtnText="Submit"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      <div className="flex flex-column gap-2">
        {!change && (
          <CheckboxComp
            isChecked={formData.schedule_publish}
            onChange={handleCheckBox}
            label="Schedule publishing"
          />
        )}
        {formData?.schedule_publish ||
        status === "approved" ||
        tabActive === "2" ? (
          <div className="flex align-center gap-4">
            <DatePickerComp
              value={date}
              setValue={setDate}
              disabledDate={disableStartDate}
              onChange={handleDatePicker}
            />
            <TimePickerComp
              date={date}
              onChange={handleTimePicker}
              disabled={!date}
            />
          </div>
        ) : null}
      </div>
    </ModalComp>
  );
}

export default DateTime;
